import sunTexture from "../assets/sun.jpg";

export const starsConfig = {
  sun: {
    texture: sunTexture,
    size: 10
  }
};
